import { Typography } from '@navi/web-ui/lib/primitives';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';
import { createQueryParams, readQueryParams } from '@cp/src/utils/QueryParamsHelper';
import { useNavigate } from 'react-router-dom';
import { toast } from '@navi/web-ui/lib/primitives/Toast';
import { fetchMockRunsList, initiateMock } from '../../../actions/FieldAllocationAction';
import { FIELD_ALLOCATION_KEY, MOCK_RUN_HISTORY_FETCH_TYPE } from '../../../types';
import StepsButton from '../StepsButton';

interface ConfirmationStepProps {
  handleCloseModal: () => void;
}

const ConfirmationStep: React.FC<ConfirmationStepProps> = ({ handleCloseModal }) => {
  const dispatch = useDispatch();
  const initiateMockLoading = useSelector(
    (state: RootState) => state.fieldAllocation?.initiateMockLoading
  );

  const queryParams = readQueryParams();
  const navigate = useNavigate();

  const selectMockHandler = (mockId: string) => {
    const updatedTableParams = { ...queryParams };
    updatedTableParams[FIELD_ALLOCATION_KEY] = {
      ...queryParams[FIELD_ALLOCATION_KEY],
      selectedId: mockId
    };
    const url = createQueryParams(updatedTableParams);
    navigate(url, { replace: true });
  };

  const successCallBack = () => {
    handleCloseModal();
    dispatch(fetchMockRunsList(MOCK_RUN_HISTORY_FETCH_TYPE.CURRENT_MONTH, selectMockHandler));
    toast('Mock initiated successfully', { type: 'success' });
  };

  const onConfirm = () => {
    dispatch(initiateMock(successCallBack));
  };

  return (
    <>
      <Typography variant="h4" color="var(--navi-color-gray-c2)">
        Process will start preparing inputs which cannot be cancelled
      </Typography>
      <StepsButton
        onCancel={handleCloseModal}
        onAction={onConfirm}
        actionText="Confirm (2/2)"
        isLoading={initiateMockLoading}
      />
    </>
  );
};

export default ConfirmationStep;
